import { CoordinatesModel } from '@marketplace-web/shipping/checkout-shipping-data'

export const getLocationCoordinates = () =>
  new Promise<CoordinatesModel | void>((resolve, reject) => {
    if (!navigator?.geolocation) {
      resolve()

      return
    }

    navigator.geolocation.getCurrentPosition(
      position =>
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }),
      reject,
    )
  })
